import { BaseClass, Logger } from 'ngx-elvis-ds';
import { SAMService } from '../sam.service';
import { SAMCommands } from './sam-commands';

export class SAMRouter extends BaseClass {

  private commandsMap: Array<{name: string, commands?: string[]}> = SAMCommands.all;

  constructor(
    private sam: SAMService,
  ) {
    super();
  }

  public dispatch(message) {
    let channel = this.commandsMap.find( (cd) => cd.commands.includes(message.Command) );

    if (message.Destination === 'JHIM') {
      channel = { name: 'jhim' };
    }

    if (channel) {
      this.sam.channels[channel.name].next(message);
    } else {
      Logger.warn('Error::UnhandledCommand', message);
    }
  }
}
